import { Component, inject, Input, OnInit } from "@angular/core";
import { SharedMaterialModule } from "@shared/modules/shared-material.module";
import { SharedDsnModule } from "@shared/modules/shared-dsn.module";
import { BadgeRocketComponent } from "../../../../../shared/components/badge-rocket/badge-rocket.component";
import { CompanyEntity, ReportEntity } from "@arch/domain/entity";
import { ContactService } from "@app/shared/services/contact.service";
import { MatDialog } from "@angular/material/dialog";
import { RequestProductGrowthComponent } from "@app/shared/components/request-product-growth/request-product-growth.component";

@Component({
    selector: "app-report-adjustments-without-analisysplus",
    imports: [SharedMaterialModule, SharedDsnModule, BadgeRocketComponent],

    templateUrl: "./report-adjustments-without-analisysplus.component.html",
    styleUrl: "./report-adjustments-without-analisysplus.component.scss"
})
export class ReportAdjustmentsWithoutAnalisysplusComponent implements OnInit {
    @Input() titulo: string = "";
    @Input() descricao: string = "";
    @Input() imagemSrc: string = "";

    @Input({ required: true }) company: CompanyEntity;

    @Input({ required: true }) report: ReportEntity;

    private readonly contactService = inject(ContactService);
    private readonly dialog = inject(MatDialog);
    public contact = this.contactService.get();
    public indicadores = [
        {
            titulo: "Projeção",
            descricao:
                "Simule os próximos resultados da empresa através do modelo de regressão linear.",
            imagemSrc: "/images/projection-y.png",
            active: false
        },
        {
            titulo: "Orçamento",
            descricao:
                "Ative o orçamento e identifique oportunidades de crescimento.",
            imagemSrc: "/images/budget-y.png",
            active: false
        }
    ];
    public objetivos = [
        {
            titulo: "Objetivo",
            descricao: "Defina e acompanhe objetivos para cada indicador.",
            imagemSrc: "/images/objective-y.png"
        }
    ];

    constructor() {}

    ngOnInit(): void {}

    public onRequestAnalysisPlus(): void {
        this.dialog.open(RequestProductGrowthComponent, {
            width: "386px",
            maxWidth: "386px",
            data: {
                title: "Análise Plus",
                imageSrc:
                    "https://nucont-imgs.s3.amazonaws.com/novidades/analise-plus-objetivos.gif",
                subtitle: "Projeção, orçamento e objetivos",
                description:
                    "Com a Análise Plus, você antecipa resultados com <span class='font-weight-semi-bold'>Projeções</span>, controla despesas e receitas, acompanha o <span class='font-weight-semi-bold'>Orçamento</span> e define <span class='font-weight-semi-bold'>Objetivos</span> por indicador.",
                hint: "Essa funcionalidade <span class='font-weight-semi-bold'>não está disponível</span> no seu plano atual. Solicite o contato abaixo para incluir a Análise Plus no seu plano.",
                cta: "Solicitar Análise Plus",
                company: this.company,
                package: "Análise Plus",
                licenses: 1,
                options: {
                    addedValue: "0",
                    period: ""
                }
            }
        });
    }
}
